import React from 'react';
import { PaymentCardForm, PaymentCardFormProps } from '@cloudbeds/payment-tokenization';

import { NextAction, PaymentElementResponse } from '../../../@types';
import { queryPaymentMethodHash } from '../../../queries/methodHash';
import { useCommonOptionsStore } from '../../../store';
import {
  tokenexPaymentMethodHashPayloadFactory,
} from '../../../factories/query-payment-method-hash-payload';
import { nextActionHandler } from '../../../handlers/nextActionHandler';

import { CreditCardFormProps } from './creditCard.types';

export const TokenexCardForm = React.forwardRef((
  cardProps: CreditCardFormProps,
  ref: any,
) => {
  const lang = useCommonOptionsStore(state => state.lang);
  const propertyId = useCommonOptionsStore(state => state.propertyId);
  const apiKey = useCommonOptionsStore(state => state.apiKey);

  const props: PaymentCardFormProps = React.useMemo(() => {
    const { firstName = '', lastName = '' } = cardProps.guest || {};

    return {
      validateOnChange: false,
      validateOnBlur: false,
      onLoadStart: () => {},
      onLoadEnd: () => {},
      onAuthExpired: () => {},
      lang,
      defaultValues: {
        firstName,
        lastName,
        fullName: `${firstName} ${lastName}`.trim(),
        ...(cardProps.guest || {}).billingDetails || {},
      },
      onSubmitHandler: async (data: any) => {
        // @ hashing payment method
        const hashPayload = tokenexPaymentMethodHashPayloadFactory(data);
        const {
          hash: paymentMethodHash,
          error: hashError,
        } = await queryPaymentMethodHash(+propertyId!, apiKey!, hashPayload);
        if (hashError && cardProps.onError) cardProps.onError(hashError);

        const responseData: PaymentElementResponse = {
          ...data,
          hashPayload,
          ...(data.cvv && !data.cvc && { cvc: { ...data.cvv } }),
          paymentMethod: 'card_tokenex',
          paymentMethodHash,
        };

        const nextAction: NextAction = await cardProps.onSubmit({ ...responseData });
        await nextActionHandler(nextAction);
      },
      onChangeHandler: (data: any) => { window.console.log(data); },
      onErrorHandler: (error: any) => {
        if (cardProps.onError) {
          cardProps.onError({
            [error.key || 'tokenex']: error.message || 'Unknown error',
          });
        }
      },
    };
  }, [lang, propertyId, apiKey, cardProps]);

  return <PaymentCardForm {...props} ref={ref} />;
});
